import { Outlet } from 'react-router-dom';

export const DevicesOutlet = () => <Outlet />;
